import config from 'config';

/** @deprecated use $util/getLandingUrlFromLocation instead */
export const getLandingUrlFromProps = (location) => {
  const domains = config.get('public.cookie.domains');

  if (!location.hostname || !location.origin) {
    throw new Error('location pageProps does not include hostname and origin properties');
  }
  const { hostname, origin } = location;

  const match = domains.find((domain) => hostname.endsWith(domain));
  if (!match) {
    throw new Error(`Location hostname ${hostname} is not whitelisted in (${domains})`);
  }

  return origin;
};

export const getProductionDomainFromLocale = (
  locale,
  productionDomains = config.get('public.i18n.productionDomains')
) => {
  const productionDomain = productionDomains.find((match) => match.locale === locale);

  if (!productionDomain) {
    throw new Error(`There is not production domain configured for the ${locale} locale`);
  }

  return productionDomain.domain;
};
